import { useDialog } from '@/components/shared/hooks/useDialog';

export const useValidationClose = () => {
  const { opened, setOpened, toggleDialog } = useDialog();

  const onClose = () => {
    setOpened(true);
  };

  const onLeave = () => {
    setOpened(false);
  };

  return {
    onClose,
    onLeave,
    showCloseAlert: opened,
    setShowCloseAlert: setOpened,
    toggleCloseAlert: toggleDialog,
  };
};
